import { render, staticRenderFns } from "./BaAdminAllHoldings.vue?vue&type=template&id=0264b4a5&scoped=true&"
import script from "./BaAdminAllHoldings.vue?vue&type=script&lang=js&"
export * from "./BaAdminAllHoldings.vue?vue&type=script&lang=js&"
import style0 from "./BaAdminAllHoldings.vue?vue&type=style&index=0&id=0264b4a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0264b4a5",
  null
  
)

export default component.exports